export default class EventsSearch {
	constructor() {
		this.filters = $('#event-search-form');
		this.stateFilter = $('#events-filter-state');
		this.monthFilter = $('#events-filter-month');
		this.results = $('#event-search-results');
		this.reset = $('[type="reset"]');
		this.data = {};
		this.searchTimeout = 0;

		// optional data params
		this.pageSize = this.results.data('page-size') || 12;
		this.pagination = this.results.data('pagination') != undefined && this.results.data('pagination') ? 1 : 0;
		this.state = this.results.data('state') || '';

		this.init();
	}

	init() {
		if( ! this.state ) {
			if( ! this.filters.length || ! this.results.length ) return false;

			// set filters from hash
			let hash = document.location.hash.replace(/^#/, '').split('/');
			let state = hash[0];
			let format = (hash.length > 1 ? hash[1] : '').split(',');

			if( state.length ) {
				this.stateFilter.val(state);;
			}

			if( format.length ) {
				format.forEach( (value) => {
					$(":checkbox[name='event-format[]'][value='" + value + "']").attr('checked', true);
				});
			}

			// reset button
			this.reset.on('click', (event) => {
				$(":checkbox", this.filters).attr('checked', false);
				this.stateFilter.val('');
				this.search();
			});

			// search on form input change
			$(':input', this.filters).on('input', (event) => {
				clearTimeout(this.searchTimeout);
				this.searchTimeout = setTimeout(()=>{
					this.search();
				}, 500);
			});

		} else {
			let state = this.state;
			let format = [];
		}

		// pagination controls
		$(this.results).on('click', '.page-link', (event) => {
			event.preventDefault();
			var page = $(event.currentTarget).data('page');
			this.search(page);
		});

		this.search();
	}

	search(page=1) {
		var $formats = $(':input[name="event-format[]"]:checked', this.filters);
		var $categories = $(':input[name="event-category[]"]:checked', this.filters);

		var formats = [], categories = [];
		var states = this.state ? [this.state] : [this.stateFilter.val()];
		var month = this.monthFilter ? this.monthFilter.val() : '';

		// empty the results panel but maintain its height
		var h = $(this.results).height();

		$(this.results)
			.height(h)
			.addClass('loading')
			.append('<div class="ajax-results-spinner"><span class="loading-icon fas fa-spinner fa-spin"></span> Loading...</div>');


		$formats.each((n, item)=>{
			formats.push(item.value);
		});

		$categories.each((n, item)=>{
			categories.push(item.value);
		});


		$.ajax({
			method: 'post',
			url: window.ff_settings.site_url + '/wp-json/dsa/v1/events?html=1',
			dataType: 'json',
			data: {
				formats: formats.join(','),
				categories: categories.join(','),
				states: states.join(','),
				month: month,
				page_size: this.pageSize,
				pagination: this.pagination,
				// pagination
				page: page
			}
		}).done( (response) => {
			// do something with data
			this.data = response;
			$(this.results)
				.html(response.html)
				.removeClass('loading')
				.removeAttr('style');
		});
	}
}